import EditorDialog from "./EditorDialog";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import { categoryIconsMap } from "../../config/categoryIcons";
import { parsePersianNumber } from "../../utils/persianNumber";

import { formatPersianNumber as priceFormatter } from "../../utils/persianNumber";

const MenuPreviewDialog = ({ open, onClose, title, categories }) => (
  <EditorDialog open={open} onClose={onClose} title="پیش‌نمایش منو" maxWidth="md">
    <div className="rounded-2xl bg-[#fffaf5] p-4 sm:p-6">
      <h2 className="text-center text-xl font-black text-gray-900">{title || "منوی بدون عنوان"}</h2>
      <div className="mt-6 space-y-6">
        {categories.map((category) => {
          const Icon = categoryIconsMap[category.icon];
          return (
            <section key={category._id || category.clientId || category.name}>
              <h3 className="mb-3 flex items-center gap-2 font-bold text-gray-800">
                {Icon && <Icon style={{ color: category.iconColor }} aria-hidden="true" />}
                {category.name}
              </h3>
              <div className="grid gap-3 sm:grid-cols-2">
                {category.items.map((item) => (
                  <article key={item._id || item.clientId || item.name} className="flex gap-3 rounded-xl border border-orange-100 bg-white p-3">
                    {item.image && <img src={resolveMediaUrl(item.image)} alt="" className="h-16 w-16 rounded-lg object-cover" />}
                    <div className="min-w-0 flex-1">
                      <p className="font-bold text-gray-900">{item.name}</p>
                      {item.description && <p className="mt-1 line-clamp-2 text-xs text-gray-500">{item.description}</p>}
                      <p className="mt-2 text-sm font-bold text-primary">{priceFormatter(parsePersianNumber(item.price) || 0)} تومان</p>
                    </div>
                  </article>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  </EditorDialog>
);

export default MenuPreviewDialog;
